import * as Sentry from "@sentry/react";
import { main } from "../react/main";

const { VITE_SENTRY_DSN, VITE_SENTRY_ENVIRONMENT } = import.meta.env;

Sentry.init({
  dsn: VITE_SENTRY_DSN,
  environment: VITE_SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0.01, // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring. We recommend adjusting this value in production.
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/], // TODO: Change this when using a API backend split from the frontend
  // Session Replay
  replaysSessionSampleRate: 0, // 0.01, TODO: Temporary disabled // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // 1.0, TODO: Temporary disabled // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

main();
